const autoSubmitForm = document.querySelectorAll('.auto-submit-form');

autoSubmitForm.forEach(form => {
    form.addEventListener('change', e => {
        form.submit();
    });
});

const autofillForm = document.querySelectorAll('.autofill-form');

autofillForm.forEach(form => {
    const inputs = form.querySelectorAll(
        'input[type="text"], input[type="email"], input[type="tel"], input[type="date"]',
    );
    const formName = form.dataset.formName;
    const storedValues = window.localStorage.getItem(formName);

    form.addEventListener('submit', e => {
        e.preventDefault();

        const inputValues = Object.fromEntries(
            Array.from(inputs).map(input => [input.name, input.value]),
        );

        window.localStorage.setItem(formName, JSON.stringify(inputValues));
        form.submit();
    });

    if (storedValues) {
        setTimeout(() => {
            Object.entries(JSON.parse(storedValues)).forEach(([name, value]) => {
                const storedInput = form.querySelector('input[name="' + name + '"]');

                if (storedInput && !storedInput.value) {
                    storedInput.value = value;
                    storedInput.classList.add('autofilled');
                }
            });
        }, 500);
    }
});
